import { jsBridge } from './bridge';
import { BRIDGE_NAME, BRIDGE_STATUS, SCHEMA } from './bridge-const';
import { checkSchemaVersion, checkAppVersion } from './check-version';

// 默认登陆信息
const defaultLoginInfo = {
    app_id: '10086',
    app_ver: '9.9.9',
    token_type: 'Bearer',
    environment: 'sharingPage'
};

//根据areaCode获取城市code
const getCityCode = areaCode => {
    return (areaCode ? Math.floor(areaCode * 1 / 100) * 100 : '') + '';
};

/**
 * @return http://showdoc.nevint.com/index.php?s=/lifestyle&page_id=4840 1
 */
const getLoginInfoBridge = async () => {
    return new Promise(resolve => {
        jsBridge(BRIDGE_NAME.GET_LOGIN_INFO, {}, loginInfo => {
            console.log('resolve:loginInfo', loginInfo);
            const res = loginInfo;
            if ((loginInfo.app_id || '').indexOf('10001') === 0) {
                res.environment = 'android';
            } else if ((loginInfo.app_id || '').indexOf('10002') === 0) {
                res.environment = 'ios';
            }
            res.mobile = res.mobile || res.phone || '';
            resolve(res);
        }).then(bridgeStatus => {
            console.log('bridgeStatus', bridgeStatus);
            if (bridgeStatus === BRIDGE_STATUS.NO_BRIDGE) {
                const options = defaultLoginInfo;
                resolve(options);
            }
        });
    });
};

/**
 * 一键加群
 * @param {*} group_id 群聊ID
 * @param {*} inviter_id 邀请人account_id
 */
const applyJoinGroupBridge = async (group_id, inviter_id) => {
    return new Promise((resolve, reject) => {
        jsBridge(
            'applyJoinGroup',
            {
                group_id,
                inviter_id
            },
            res => {
                resolve(res);
            }
        ).then(bridgeStatus => {
            if (bridgeStatus !== BRIDGE_STATUS.DONE) {
                reject({
                    type: 'not_support',
                    result: {}
                });
            }
        });
    });
};

/**
 *
 * @param{string} content, toast content
 *
 * http://showdoc.nevint.com/index.php?s=/lifestyle&page_id=4840 4
 */
const showToastBridge = content => {
    jsBridge('showToast', {
        content
    });
};

/**
 * 添加文本到客户端剪贴板
 * @param{string} content, copy content
 *
 */
const copyBridge = content => {
    return new Promise(resolve => {
        jsBridge('copyTxt', { content }, res => {
            resolve(res);
        });
    });
};

/**
 * 跳转至客户端登陆页
 * 
 */
const redirectToLoginViewBridge = async () => {
    jsBridge('redirectToLoginView');
};

/**
 * 跳转至客户端页面
 * @param{string} pageLink, 跳转页面地址
 * @param{boolean} closeFormerPage, 是否删除跳转后的前一页
 * 
 */
const redirectToViewBridge = (pageLink, closeFormerPage = false) => {
    jsBridge('jumpToView', {
        closeFormerPage,
        content: pageLink
    });
};

/**
 * 添加到系统日历,仅ios支持
 * @param{Object} content, 跳转页面地址
 * @param{String} content.title, 标题
 * @param{String} content.location, 地址 (optional)
 * @param{String} content.startTime, 开始时间,采用timestamp格式
 * @param{String} content.endTime, 结束时间，采用timestamp格式
 * @param{String} content.eventId, 该行程的ID (optional)
 * @param{String} content.notes, 关于该行程的一些详细描述 (optional)
 */
const addEventBridge = content => {
    jsBridge('addEventToSchema', content);
};

// 普通分享 http://showdoc.nevint.com/index.php?s=/lifestyle&page_id=4840 9.showShareViewV2
const showShareViewV2Bridge = (content, eventTypeObject) => {
    const params = { content };
    // 专题类型，分享时传入event对象，该对象客户端用来考虑积分下发，默认情况下客户端根据content自动生成，
    // eventTypeObject ex: {type: XXX, info: {resource_id: XX, resource_type: XX}}
    eventTypeObject && (params.event = eventTypeObject);
    return new Promise(resolve => {
        jsBridge('showShareViewV2', params, res => {
            resolve(res);
        });
    });
};

// 带图片分享 http://showdoc.nevint.com/index.php?s=/lifestyle&page_id=4840 9.showShareViewV2
// @param{Array} [{
//     channel: actionSave, weibo, wechatfriend, wechatcircle, niofriend
//     action: share_image, share_webPage, share_miniProgram, action
//     dataType: base64,
//     base64Images: [], ugc两张图片，瀑布流和分享图
//     data: 具体分享内容,
//     desc: 分享文案
//     content: [{ // 文案带话题等
//          "type": 2,
//          "topic_id": 0,
//          "name": '不服来战'
//     }, {
//          "type": 0,
//          "content": 'XXX'
//     }]
// }]

const showShareMediaBridge = content => {
    const shareContent = content.map(item => {
        const info = {
            channel: item.channel,
            title: item.title || '',
            desc: item.desc || '',
            shareUrl: item.shareUrl || '',
            base64Images: item.base64Images || []
        };
        item.imgUrl && (info.imgUrl = item.imgUrl);
        info['function'] = item.action;
        item.content && (info.content = item.content);
        info[item.dataType] = item.data;
        return info;
    });
    return new Promise(resolve => {
        jsBridge(
            'showShareViewV2',
            {
                content: shareContent
            },
            res => {
                resolve(res);
            }
        );
    });
};
/**
 *
 * @param{string} name, notification name
 * @param{object} params,
 *
 * @example sendNotificationBridge('registration_cancel', {registration_id: 'xx'})
 */
const sendNotificationBridge = (name, params = {}) => {
    if (!name) {
        // name is required
        return;
    }
    jsBridge(BRIDGE_NAME.SEND_NOTIFICATION, {
        name,
        params
    });
};

/**
 * @description jump to chat view
 * @param{string} id, im_id when app_ver >= 3.0.0,rongyun.external_id when app_ver < 3.0.0
 * @param{string} type, "private" | "group"
 * @param title, (optional)
 */
const goToChatBridge = async (id, type, title) => {
    if (!id) {
        // id is required
        return;
    }
    const typeMap = {
        private: true,
        group: true
    };
    if (!typeMap[type]) {
        // type is required in "group" or "private"
        return;
    }

    const loginInfo = await getLoginInfoBridge();
    const env = loginInfo['environment'];
    const ver = loginInfo['app_ver'];
    let schema = '';

    if (env === 'android' && checkAppVersion(ver, '3.0.0') < 0) {
        schema = `rong://cn.com.weilaihui3/conversation/${type}?targetId=${id}&title=${title}`;
    } else if (env === 'android' && checkAppVersion(ver, '3.0.0') > -1) {
        schema = `nio://conversation?id=${encodeURIComponent(
            id
        )}&title=${encodeURIComponent(title)}&type=${type}`;
    } else if (env === 'ios') {
        schema = `nio://conversation?id=${encodeURIComponent(
            id
        )}&name=${encodeURIComponent(title)}&type=${type}`;
    }
    jsBridge(BRIDGE_NAME.JUMP_TO_VIEW, {
        content: schema
    });
};

/**
 * 跳转至地图
 * @param{object} params,
 * @param{String} params.address 地址名称
 * @param{String} params.poiName 地址poiname
 * @param{Object} params.gps 地址经纬度
 * @param{Object} params.gps['BD-09'] 百度坐标系{longitude, latitude}
 * @param{Object} params.gps['GCJ-02'] 高德坐标系{longitude, latitude}
 *
 * @example goToMapBridge({address: 'XXX', poiName: 'YYY', gps: {'BD-09': {longitude: 'XXX', latitude: 'XXX'}})
 */
const goToMapBridge = ({ address, poiName, gps }) => {
    return new Promise(resolve => {
        jsBridge(
            BRIDGE_NAME.GO_MAP,
            {
                content: {
                    address,
                    poi_name: poiName,
                    gps
                }
            },
            res => {
                resolve({
                    type: 'success',
                    result: res
                });
            }
        ).then(bridgeStatus => {
            console.log('bridgeStatus::', bridgeStatus);
            if (bridgeStatus !== BRIDGE_STATUS.DONE) {
                resolve({
                    type: 'not_support',
                    result: {}
                });
            }
        });
    });
};

/**
 * 客户端数据上报
 * @param{String} event 点位名称
 * @param{Object} data 具体点位数据
 *
 */
const onMtaEventBridge = (event, data) => {
    if (!event) {
        // event is required
        return;
    }
    jsBridge('onMtaEvent', {
        event,
        data
    });
};

/**
 * 关闭当前页面
 * @param{Object} params 
 * @param{Boolean} params.needMta ios是否需要上报时常
 *
 */
const closePageBridge = async ({ needMta = true } = {}) => {
    if (needMta) {
        const { environment: env } = await getLoginInfoBridge();
        if (env === 'ios') {
            window.onbeforeunload && window.onbeforeunload();
        }
    }
    jsBridge(BRIDGE_NAME.CLOSE_PAGE);
};

/**
 * @description authorizationStatus,soundSetting ,alertSetting,badgeSetting,lockScreenSetting
 * @description authorized标识有权限
 * @return {Promise<*>}
 */
const getNotificationSettings = async () => {
    const { environment: env } = await getLoginInfoBridge();
    if (env !== 'ios') {
        return {
            type: 'not_support',
            result: {}
        };
    }

    return new Promise(resolve => {
        jsBridge(BRIDGE_NAME.GET_NOTIFICATION_SETTINGS, {}, res => {
            const { result = {} } = res;
            resolve({
                type: 'success',
                result
            });
        }).then(bridgeStatus => {
            if (bridgeStatus !== BRIDGE_STATUS.DONE) {
                resolve({
                    type: 'not_support',
                    result: {}
                });
            }
        });
    });
};

// 跳转系统设置，目前只有IOS提供
const openApplicationSetting = async () => {
    const { environment: env } = await getLoginInfoBridge();
    if (env === 'android') {
        return;
    }
    jsBridge(BRIDGE_NAME.OPEN_APPLICATION_SETTING);
};

/**
 * 驾照上传
 * @param{String} resource_id 资源id
 * @param{String} resource_type 
 * @param{String} mtaMainPage 数据源
 * @param{String} upload_result 驾照上传状态（判断是否是重复上传）
 * @return {Promise<*>}
 */
const uploadLicense = async (
    resource_id,
    resource_type,
    mtaMainPage,
    upload_result
) => {
    return new Promise(resolve => {
        jsBridge(
            BRIDGE_NAME.UPLOAD_LICENSE,
            {
                params: {
                    resource_id: resource_id + '',
                    resource_type,
                    source: mtaMainPage
                },
                upload_result
            },
            res => {
                const { result = {} } = res;
                resolve({
                    type: 'success',
                    result
                });
            }
        ).then(bridgeStatus => {
            if (bridgeStatus !== BRIDGE_STATUS.DONE) {
                resolve({
                    type: 'not_support',
                    result: {}
                });
            }
        });
    });
};

/**
 * 发布ugc
 * content在type为0时为普通文本， 1时@，2时#
 * @param{Array} content 发布内容
 * @param{Object} content[index] {type:{0,1,2}, content: 'XXX', topic_id: XXX, account_id:XXX}
 * @return {Promise<*>}
 */
const postUGC = async content => {
    return new Promise(resolve => {
        jsBridge(
            BRIDGE_NAME.POST_UGC,
            {
                content
            },
            res => {
                const { result, data = {} } = res;
                resolve({
                    type: result,
                    result: data
                });
            }
        ).then(bridgeStatus => {
            if (bridgeStatus !== BRIDGE_STATUS.DONE) {
                resolve({
                    type: 'not_support',
                    result: {}
                });
            }
        });
    });
};

// 获取定位
const getLocationBridge = async () => {
    return new Promise(resolve => {
        jsBridge('getLocation', {}, responseData => {
            const result = {};
            if (!responseData.isInvalid) {
                result.point = {
                    lat: responseData.latitude,
                    lng: responseData.longitude
                };
                result.city = {
                    city: responseData.city,
                    cityCode: getCityCode(responseData.cityCode)
                };
                resolve({
                    type: 'success',
                    result
                });
            } else {
                result.message = '获取定位失败！';
                resolve({
                    type: 'error',
                    result
                });
            }
        });
    });
};

/**
 * 跳转到schema接口
 * @param{String} 页面名称，参考bridge-const.js中SCHEMA的属性名
 * @param{Object} params 页面参数
 * @return {Promise<*>}
 */
const redirectToSchema = async (name, params) => {
    const loginInfo = await getLoginInfoBridge();
    const env = loginInfo['environment'];
    const ver = loginInfo['app_ver'];
    if (env === 'sharingPage' || !checkSchemaVersion(name, ver, env)) {
        return {
            type: 'not_support',
            result: {}
        };
    } else {
        const paramsArray = [];
        Object.keys(params).forEach(k => {
            paramsArray.push(`${k}=${params[k]}`);
        });
        redirectToViewBridge(`${SCHEMA[name].name}?${paramsArray.join('&')}`);
        return {
            type: 'success',
            result: {}
        };
    }
};

/**
    获取当前用户车辆信息
    @return {Promise<*>}
 */
const getCurrentVehicleProfile = async () => {
    return new Promise(resolve => {
        jsBridge('currentVehicleProfile', {}, responseData => {
            resolve({
                type: 'success',
                result: responseData
            });
        }).then(bridgeStatus => {
            if (bridgeStatus === BRIDGE_STATUS.NO_BRIDGE) {
                resolve({ result: { vehicle_id: null } });
            }
        });
    });
};

/**
 * 发送位置到车机
 * @param{Object} content
 * @param{String} content.v_id 车辆id
 * @param{String} content.u_id 用户profile_id
 * @param{String} content.latitude 
 * @param{String} content.longitude 
 * @param{String} content.poi_name 位置名称
 * @return {Promise<*>}
 */
const sendPOI = async content => {
    return new Promise(resolve => {
        jsBridge('sendPOI', { content }, responseData => {
            resolve({
                type: 'success',
                result: responseData
            });
        });
    });
};

/**
 * 发表评论
 * @param{Object} param
 * @param{String} param.placeholder 可选参数 
 * @param{String} param.resource_type 
 * @param{String} param.resource_id 
 * @param{String} param.comment_id 可选参数
 * @param{int} param.countLimit 可选参数
 * @return {Promise<*>}
 */
const sendComment = async param => {
    return new Promise(resolve => {
        jsBridge(
            BRIDGE_NAME.SEND_COMMENT,
            {
                content: param
            },
            responseData => {
                resolve({
                    type: 'success',
                    result: responseData
                });
            }
        );
    });
};

/*
 * 社群
 */
/**
 * 发送邀请好友入群消息
 * @param{Object} param
 * @param{String} param.id decodeURIComponent(communityId) 
 * @return {Promise<*>}
 */
const communityAddMembers = async param => {
    return new Promise(resolve => {
        jsBridge(BRIDGE_NAME.COMMUNITY_ADD_MEMBERS, param, responseData => {
            resolve({
                type: 'success',
                result: responseData
            });
        });
    });
};

// 下拉框选择
const showSelector = async param => {
    return new Promise(resolve => {
        jsBridge(BRIDGE_NAME.SHOW_SELECTOR, param, responseData => {
            resolve({
                type: 'success',
                result: responseData
            });
        });
    });
};

/**
 * 发送卡券领取消息
 * @param{Object} param
 * @param{String} param.send_id 用户IMid
 * @param{String} param.send_name 用户name
 * @return {Promise<*>}
 */
const sendCouponNotifyMsg = ({ send_id, send_name }) => {
    jsBridge('sendCouponNotifyMsg', {
        send_id,
        send_name
    });
};

/**
 * 更新卡券状态
 * @param{String} status 卡券状态 默认received
 * @return {Promise<*>}
 */
const changeCouponState = (status = 'received') => {
    jsBridge('changeCouponState', {
        coupon_transfer_status: status
    });
};

/**
 * 下载视频
 * @param{String} url 视频link
 * @return {Promise<*>}
 */
const downloadVideo = url => {
    jsBridge(
        'downloadVideo',
        { url },
        resp => resp.status === 'start' && showToastBridge('开始下载视频')
    );
};

// 显示客户端loading动画
const showNativeLoading = () => {
    jsBridge(BRIDGE_NAME.SHOW_LOADING);
};

// 停止客户端loading动画
const destroyNativeLoading = () => {
    jsBridge(BRIDGE_NAME.DESTROY_LOADING);
};

// 安卓允许或阻止原生滑动
// params : { "disallow_intercept" : "true"/"false"}
const requestEventAndroid = params => {
    jsBridge(BRIDGE_NAME.REQUEST_EVENT, params);
};

/**
 * 弹起客户端输入组件，并返回用户输入内容
 * @param{Object} params 
 * @param{Object} params.content
 * @param{String} params.content.placeHolder 
 * @param{Int} params.content.countLimit 限制字数
 * @param{Int} params.content.filterWordsStatus 1检查违禁词，如果有违禁词，提示用户修改，直至没有违禁词，
 *                                              0不做处理
 *                                              2对违禁词做处理，返回后端处理后的文案
 * @return {Promise<*>}
 */
const getContentFromUser = params => {
    return new Promise(resolve => {
        jsBridge(BRIDGE_NAME.GET_CONTENT_FROM_USER, params, responseData => {
            resolve({
                type: 'success',
                result: responseData
            });
        }).then(bridgeStatus => {
            if (bridgeStatus !== BRIDGE_STATUS.DONE) {
                resolve({
                    type: 'not_support',
                    result: {}
                });
            }
        });
    });
};

// 安卓获取滑动最小判定标准
// return : {"touchSlop": 20}
const touchSlopAndroid = async params => {
    return new Promise(resolve => {
        jsBridge(BRIDGE_NAME.TOUCH_SLOP, params, responseData => {
            resolve({
                type: 'success',
                result: responseData
            });
        });
    });
};

/**
 * 保存图片到相册
 * @param{Object} params 
 * @param{Array} params.base64Images base64字符数组
 * @return {Promise<*>}
 */
const savePhotosAlbum = params => {
    return new Promise(resolve => {
        jsBridge(BRIDGE_NAME.SAVE_PHOTOS_ALBUM, params, responseData => {
            resolve({
                type: 'success',
                result: responseData
            });
        }).then(bridgeStatus => {
            if (bridgeStatus !== BRIDGE_STATUS.DONE) {
                resolve({
                    type: 'not_support',
                    result: {}
                });
            }
        });
    });
};

/**
 * 获取客户端信息
 * @return {Promise<*>}
 */
const getDeviceInfo = () => {
    return new Promise(resolve => {
        jsBridge(BRIDGE_NAME.GET_DEVICE_INFO, {}, responseData => {
            resolve({
                type: 'success',
                result: responseData
            });
        }).then(bridgeStatus => {
            if (bridgeStatus !== BRIDGE_STATUS.DONE) {
                resolve({
                    type: 'not_support',
                    result: {}
                });
            }
        });
    });
};

/**
 * 选择图片
 * @param{Object} params 
 * @param{number} params.maxSize 最多可以选择几张图片
 * @return {Promise<*>}
 */
const showImgGallery = params => {
    return new Promise(resolve => {
        jsBridge(BRIDGE_NAME.SHOW_IMAGE_GALLERY, params, responseData => {
            resolve({
                type: 'success',
                result: responseData
            });
        }).then(bridgeStatus => {
            if (bridgeStatus !== BRIDGE_STATUS.DONE) {
                resolve({
                    type: 'not_support',
                    result: {}
                });
            }
        });
    });
};

/**
 * 获取本地图片相册&拍照图片
 * @return {Promise<*>}
 */
const imagePicker = () => {
    return new Promise(resolve => {
        jsBridge(BRIDGE_NAME.IMAGE_PICKER, {}, responseData => {
            resolve({
                type: 'success',
                result: responseData
            });
        }).then(bridgeStatus => {
            if (bridgeStatus !== BRIDGE_STATUS.DONE) {
                resolve({
                    type: 'not_support',
                    result: {}
                });
            }
        });
    });
};
/**
 * 群排行选择群对话
 * @param{Object} params 
 * @param{String} params.title 分享卡片标题
 * @param{String} params.imgUrl 分享卡片图片路径
 * @param{String} params.content 分享卡片描述文案
 * @param{String} params.url 打开群排行路径
 * @return {Promise<*>}
 */
const shareGroupRank = params => {
    return new Promise(resolve => {
        jsBridge(BRIDGE_NAME.SHARE_GROUP_RANK, params, responseData => {
            resolve({
                type: 'success',
                result: responseData
            });
        }).then(bridgeStatus => {
            if (bridgeStatus !== BRIDGE_STATUS.DONE) {
                resolve({
                    type: 'not_support',
                    result: {}
                });
            }
        });
    });
};
/**
 * 下载视频
 * @param{Object} params 
 * @param{String} params.video_url 下载地址
 * @return {Promise<*>}
 */
const videoDownload = params => {
    return new Promise(resolve => {
        jsBridge(BRIDGE_NAME.VIDEO_DOWNLOAD, params, responseData => {
            resolve({
                type: 'success',
                result: responseData
            });
        }).then(bridgeStatus => {
            if (bridgeStatus !== BRIDGE_STATUS.DONE) {
                resolve({
                    type: 'not_support',
                    result: {}
                });
            }
        });
    });
};
export {
    sendNotificationBridge,
    getLoginInfoBridge,
    goToChatBridge,
    showToastBridge,
    closePageBridge,
    redirectToLoginViewBridge,
    redirectToViewBridge,
    addEventBridge,
    onMtaEventBridge,
    getNotificationSettings,
    openApplicationSetting,
    showShareViewV2Bridge,
    uploadLicense,
    getLocationBridge,
    showShareMediaBridge,
    redirectToSchema,
    copyBridge,
    getCurrentVehicleProfile,
    sendPOI,
    postUGC,
    sendComment,
    communityAddMembers,
    goToMapBridge,
    showSelector,
    sendCouponNotifyMsg,
    changeCouponState,
    downloadVideo,
    showNativeLoading,
    destroyNativeLoading,
    getContentFromUser,
    requestEventAndroid,
    touchSlopAndroid,
    savePhotosAlbum,
    getDeviceInfo,
    showImgGallery,
    imagePicker,
    shareGroupRank,
    videoDownload,
    applyJoinGroupBridge
};



// WEBPACK FOOTER //
// ./src/util/jsbridge/index.js